import { IconLock } from "@tabler/icons-react";

export type ReadOnlyMotivo = "post-envio" | "no-dueno" | "orden-de-compra";

const PREFIJO: Record<ReadOnlyMotivo, string> = {
  "no-dueno": "Solo lectura · esta solicitud pertenece a otro solicitante.",
  "orden-de-compra": "Bloqueado · el prorrateo de una Orden de Compra se genera automáticamente.",
  "post-envio": "Solo lectura · la solicitud ya fue enviada a autorización.",
};

export interface ReadOnlyBannerProps {
  mensaje: string;
  motivo?: ReadOnlyMotivo;
}

/**
 * Reemplazo de `shared/ui/ReadOnlyBanner.tsx` (11 usos) · a diferencia del
 * resto de alerts del portal (siempre `variant="light"` pastel), este usa
 * fondo sólido `slate` — es deliberado en el original para distinguir
 * "bloqueado por estado" de "advertencia/error", así que se porta 1:1 en
 * vez de reusar el `Alert` pastel de Etapa 2.
 */
export function ReadOnlyBanner({ mensaje, motivo = "post-envio" }: ReadOnlyBannerProps) {
  return (
    <div className="flex items-center gap-2 rounded-md bg-slate-600 px-3 py-2.5 text-sm text-white">
      <IconLock size={16} className="shrink-0" strokeWidth={1.7} />
      <span>
        {PREFIJO[motivo]} {mensaje}
      </span>
    </div>
  );
}
